import { useEffect, useState } from "react";

export default function AdminPwaReloadPrompt() {
  const [registration, setRegistration] = useState(null);
  const [waiting, setWaiting] = useState(false);

  useEffect(() => {
    if (typeof navigator === "undefined" || !("serviceWorker" in navigator)) return undefined;

    const attach = (reg) => {
      setRegistration(reg);
      if (reg.waiting) setWaiting(true);
      const onUpdate = () => {
        if (reg.waiting) setWaiting(true);
      };
      reg.addEventListener("updatefound", () => {
        const sw = reg.installing;
        if (!sw) return;
        sw.addEventListener("statechange", () => {
          if (sw.state === "installed" && navigator.serviceWorker.controller) {
            setWaiting(true);
          }
        });
      });
      navigator.serviceWorker.addEventListener("controllerchange", () => {
        window.location.reload();
      });
      return onUpdate;
    };

    const onReady = (event) => attach(event.detail);
    window.addEventListener("dna-admin-sw-ready", onReady);

    navigator.serviceWorker.getRegistration("/admin").then((reg) => {
      if (reg) attach(reg);
    });

    return () => {
      window.removeEventListener("dna-admin-sw-ready", onReady);
    };
  }, []);

  if (!waiting) return null;

  const refresh = () => {
    registration?.waiting?.postMessage("SKIP_WAITING");
  };

  return (
    <div
      className="border-b border-amber-500/30 bg-amber-500/10 px-3 py-2 flex items-center justify-between gap-2"
      data-testid="admin-pwa-reload-prompt"
    >
      <p className="text-xs font-['Manrope'] text-amber-200">New admin version available.</p>
      <button
        type="button"
        onClick={refresh}
        className="min-h-11 px-3 text-xs font-['Manrope'] font-semibold bg-amber-500 hover:bg-amber-400 text-black"
      >
        Refresh
      </button>
    </div>
  );
}
